export const STEP_BACK = "[stepper] Go Back";
export const STEP_NEXT = "[stepper] Go Next";
export const DISABLE_BACK = "[stepper] Disable back button";
export const DISABLE_NEXT = "[stepper] Disable next button";
export const GOTO_STEP = "[stepper] Go to evaluated step";
export const ENABLE_BACK = "[stepper] Enable back button";
export const ENABLE_NEXT = "[stepper] Enable next button";

export const goBack = (force = false) => ({
  type: STEP_BACK,
  payload: {force}
});

export const goNext = (force = false) => ({
  type: STEP_NEXT,
  payload: {force}
});

export const disableNext = () => ({
  type: DISABLE_NEXT
});

export const enableNext = () => ({
  type: ENABLE_NEXT
});

export const disableBack = () => ({
  type: DISABLE_BACK
});

export const enableBack = () => ({
  type: ENABLE_BACK
});



// WEBPACK FOOTER //
// ./src/redux/actions/stepper.js